var $ = require('jQuery');

/**
 * Undeletism Class
 *
 * Inverse action of deleting - undelete the selected items.
 */
module.exports = function(marker) {
    var marker = marker;
    var form = $("#marker-action-undelete");

    // Handle restoring
    this.undeleteClicked = function() {
        marker.addIdsToForm(form);

        if(marker.idsExist()) {
            form.submit();
        } else {
            marker.displayError();
        }
    };

    // jQuery Bindings
    $("#marker-action-undelete .marker-action-button").on("click", this.undeleteClicked);
};
